import {ImportValidationFailure} from "../../../Component/Model/Dto/Staging/ImportValidationFailure";
import {ValidationFailureCategory} from "../../../Component/Model/Enum/ImportEnum";

const categoryLabels: Record<ValidationFailureCategory, string> = {
    [ValidationFailureCategory.Unspecified]: "Unspecified",
    [ValidationFailureCategory.Required]: "Required",
    [ValidationFailureCategory.InvalidValue]: "Invalid value",
    [ValidationFailureCategory.InvalidDateRange]: "Invalid date range",
    [ValidationFailureCategory.NotFound]: "Not found",
    [ValidationFailureCategory.Duplicate]: "Duplicate",
};

export const failureReason = (failure: ImportValidationFailure.Dto): string => {
    const category = categoryLabels[failure.category] ?? "Unspecified";
    return failure.field ? `${category}: ${failure.field}` : category;
};

export const failureLabel = (failure: ImportValidationFailure.Dto): string =>
    failure.section ? `${failureReason(failure)} (${failure.section})` : failureReason(failure);
